import React from 'react';

const SpatialComputingVisualization = () => {
  return (
    <div className="w-full h-96 relative overflow-hidden rounded-lg bg-gradient-to-br from-slate-900 to-slate-800 border border-slate-700">
      {/* Main visualization */}
      <div className="flex-1 relative h-96">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 800 320"
          className="absolute inset-0"
        >
          <defs>
            <linearGradient id="productionGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#374151" />
              <stop offset="100%" stopColor="#1f2937" />
            </linearGradient>
            
            <filter id="glow">
              <feGaussianBlur stdDeviation="2"/>
            </filter>
          </defs>
          
          {/* Production Line */}
          <g transform="translate(100, 80)">
            <rect width="600" height="160" rx="12" fill="url(#productionGrad)" stroke="#4b5563" strokeWidth="2"/>
            
            {/* Workstation A */}
            <g transform="translate(50, 40)">
              <rect width="110" height="80" rx="8" fill="#1f2937" stroke="#10b981" strokeWidth="2"/>
              <circle cx="20" cy="20" r="8" fill="#10b981">
                <animate attributeName="opacity" values="0.7;1;0.7" dur="2s" repeatCount="indefinite"/>
              </circle>
              <rect x="40" y="15" width="60" height="5" rx="2" fill="#6b7280"/>
              <rect x="40" y="25" width="50" height="5" rx="2" fill="#6b7280"/>
              <rect x="40" y="35" width="55" height="5" rx="2" fill="#6b7280"/>
              <text x="55" y="70" textAnchor="middle" fill="#10b981" fontSize="12" fontFamily="system-ui" fontWeight="500">
                Primary Assembly
              </text>
            </g>
            
            {/* Workstation B */}
            <g transform="translate(440, 40)">
              <rect width="110" height="80" rx="8" fill="#1f2937" stroke="#10b981" strokeWidth="2"/>
              <circle cx="20" cy="20" r="8" fill="#10b981">
                <animate attributeName="opacity" values="0.7;1;0.7" dur="2.3s" repeatCount="indefinite"/>
              </circle>
              <rect x="40" y="15" width="60" height="5" rx="2" fill="#6b7280"/>
              <rect x="40" y="25" width="50" height="5" rx="2" fill="#6b7280"/>
              <rect x="40" y="35" width="55" height="5" rx="2" fill="#6b7280"/>
              <text x="55" y="70" textAnchor="middle" fill="#10b981" fontSize="12" fontFamily="system-ui" fontWeight="500">
                Completion Bay
              </text>
            </g>
            
            {/* Bottleneck detection in center */}
            <g transform="translate(300, 80)">
              <circle cx="0" cy="0" r="35" fill="rgba(239, 68, 68, 0.1)" stroke="#ef4444" strokeWidth="2" strokeDasharray="8,4">
                <animate attributeName="r" values="35;40;35" dur="3s" repeatCount="indefinite"/>
                <animate attributeName="opacity" values="0.5;0.8;0.5" dur="3s" repeatCount="indefinite"/>
              </circle>
              <text x="0" y="-5" textAnchor="middle" fill="#ef4444" fontSize="12" fontFamily="system-ui" fontWeight="600">
                Bottleneck
              </text>
              <text x="0" y="8" textAnchor="middle" fill="#ef4444" fontSize="10" fontFamily="system-ui">
                Detected
              </text>
            </g>
          </g>
          
          {/* Worker movement path */}
          <path d="M 200 160 Q 350 120 400 160 Q 450 200 600 160" 
                stroke="rgba(6, 182, 212, 0.4)" 
                strokeWidth="4" 
                fill="none" 
                strokeDasharray="10,5">
            <animate attributeName="stroke-dashoffset" values="0;15" dur="2s" repeatCount="indefinite"/>
          </path>
          
          {/* Workers moving */}
          <circle r="6" fill="#06b6d4" filter="url(#glow)">
            <animateMotion dur="8s" repeatCount="indefinite">
              <path d="M 200 160 Q 350 120 400 160 Q 450 200 600 160 Q 450 120 400 160 Q 350 200 200 160"/>
            </animateMotion>
          </circle>
          
          <circle r="4" fill="#06b6d4" opacity="0.6">
            <animateMotion dur="8s" repeatCount="indefinite" begin="3s">
              <path d="M 200 160 Q 350 120 400 160 Q 450 200 600 160 Q 450 120 400 160 Q 350 200 200 160"/>
            </animateMotion>
          </circle>
          
          {/* Camera system */}
          <g transform="translate(400, 30)">
            <rect x="-15" y="-8" width="30" height="16" rx="4" fill="#374151" stroke="#06b6d4" strokeWidth="2"/>
            <circle cx="0" cy="0" r="4" fill="#06b6d4">
              <animate attributeName="opacity" values="0.7;1;0.7" dur="2s" repeatCount="indefinite"/>
            </circle>
            
            {/* Field of view */}
            <path d="M -12 8 L -250 70 L 250 70 L 12 8 Z" fill="rgba(6, 182, 212, 0.06)" opacity="0.8"/>
          </g>
          
          {/* Analytics panel */}
          <g transform="translate(400, 280)">
            <rect x="-250" y="-25" width="500" height="50" rx="8" fill="rgba(30, 41, 59, 0.9)" stroke="rgba(71, 85, 105, 0.4)" strokeWidth="1"/>
            
            {/* Live metrics */}
            <g transform="translate(-150, 0)">
              <text x="0" y="-5" textAnchor="middle" fill="#ef4444" fontSize="16" fontFamily="system-ui" fontWeight="600">
                ↓ 32% Wait Time
              </text>
              <rect x="-40" y="8" width="80" height="2" fill="#ef4444" opacity="0.6"/>
            </g>
            
            <g transform="translate(0, 0)">
              <circle cx="0" cy="0" r="12" fill="none" stroke="#ffffff" strokeWidth="2" opacity="0.7"/>
              <text x="0" y="4" textAnchor="middle" fill="#ffffff" fontSize="12" fontFamily="system-ui" fontWeight="700">
                AI
              </text>
            </g>
            
            <g transform="translate(150, 0)">
              <text x="0" y="-5" textAnchor="middle" fill="#10b981" fontSize="16" fontFamily="system-ui" fontWeight="600">
                ↑ 28% Efficiency
              </text>
              <rect x="-40" y="8" width="80" height="2" fill="#10b981" opacity="0.6"/>
            </g>
          </g>
          
          {/* Data streams */}
          <g opacity="0.6">
            <circle cx="200" cy="90" r="2" fill="#10b981">
              <animate attributeName="cy" values="90;270;90" dur="3s" repeatCount="indefinite"/>
              <animate attributeName="opacity" values="1;0;1" dur="3s" repeatCount="indefinite"/>
            </circle>
            <circle cx="600" cy="90" r="2" fill="#06b6d4">
              <animate attributeName="cy" values="90;270;90" dur="3.5s" repeatCount="indefinite"/>
              <animate attributeName="opacity" values="1;0;1" dur="3.5s" repeatCount="indefinite"/>
            </circle>
          </g>
        </svg>
      </div>
    </div>
  );
};

export default SpatialComputingVisualization;